import React from 'react';
import './About.css'
import aboutHeroImage from '../../img/about-us-banner.jpg'; // Replace with the correct image path
import AboutInfo from './AboutInfo';
import WhyChooseUs from './WhyChooseUs';
import Team from './Team';
// import AboutNumbers from './AboutNumbers';
import User from './User';
import Footer from '../home-page/Footer'

// import ContactForm from './ContactForm';


export default function AboutHero() {
  return (
    <>
    <div className="about-hero-section">
      <img src={aboutHeroImage} alt="About Us" className="about-hero-image" />
      <div className="about-hero-overlay"></div>
      <div className="about-hero-content">
        <h1>About Us</h1>
        <div className="breadcrumb">
          {/* <span>Pages</span> &gt; <span>About Us</span> */}
        </div>
      </div>
    </div>
    <AboutInfo/>
    <WhyChooseUs/>
    <Team/>
    {/* <AboutNumbers/> */}
    <User/>
    <Footer/>
    {/* <ContactForm/> */}
  </>
  );
}
